import script from "./FormSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=19851eb4&lang=css"

const __exports__ = script;

export default __exports__